import { useState } from "react";
import { toast } from "react-toastify";
import { exportSamples } from "@services/samples/export";
import { exportToCSV, formatCSVData } from "@utils/export";
import { formatDateTime, actualDateTime } from "@utils/formatters";
import { getGenderLabel } from "@utils/translator/individuals";
import { getTypeLabel, type SampleType } from "@typings/entities/samples/enums";
import { SAMPLES_EXPORT_HEADS } from "@typings/entities/samples/export";
import type { Gender } from "@typings/entities/individuals";
import type { SamplesFilters } from "@services/samples/list/type";

export function useExportSamples() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async (filters?: SamplesFilters) => {
    setIsLoading(true);
    try {
      const response = await exportSamples(filters);

      if (!response.items?.length) {
        toast.warning("Nenhum dado de amostras disponível para exportar");
        return;
      }

      const translatedData = response.items.map((item) => ({
        ...item,
        type: item.type ? getTypeLabel(item.type as SampleType) : item.type,
        sampleDate: formatDateTime(item.sampleDate || null),
        anonymousIndividualGender: item.anonymousIndividualGender
          ? getGenderLabel(item.anonymousIndividualGender as Gender)
          : "",
        createdAt: formatDateTime(item.createdAt || null),
        updatedAt: formatDateTime(item.updatedAt || null),
      }));

      const formattedData = formatCSVData(translatedData, SAMPLES_EXPORT_HEADS);
      exportToCSV(formattedData, `relatorio_amostras_${actualDateTime()}`);
      toast.success("Relatório de amostras exportado com sucesso!");
    } catch {
      toast.error("Erro ao exportar relatório de amostras");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
